<template>
  <v-container>
    <v-row class="first-row" justify="center">
      <h2>Social media</h2>
    </v-row>
    <v-row justify="center">
    <v-card
      width="50%"
      color="transparent"
      outlined
    >
    <v-row justify="center">
      <v-btn
        v-for="(item, index) in socials"
        :key="index"
        :href="item['link']"
        fab
        height="128"
        width="128"
        color="transparent"
        class="sns-icon"
      >
        <v-img
          height="128"
          width="128"
          :src="item['imgPath']"
        ></v-img>
      </v-btn>
    </v-row>
    </v-card>
      </v-row>
  </v-container>
</template>

<style scoped>
  /* 各ページの行頭のmarginを揃える */
  .first-row{
    margin-top: 20px;
  }
  h2{
    color: white;
    text-shadow: 1px 2px 3px #808080;
  }
  /* アイコンのスペースを調整 */
.sns-icon{
  margin: 20px 15px 20px 15px;
}
</style>

<script>
  export default {
    name: 'Social',
    data: () => ({
      socials:[
        {'title': 'Twitter', 'imgPath': '/sns/twitter.svg', 'link': 'https://twitter.com/tmsb11'},
        {'title': 'Github', 'imgPath': '/sns/github.svg', 'link': 'https://github.com/tomosib1'},
        {'title': 'Blog', 'imgPath': '/sns/blog.png', 'link': 'https://tomosib1.hatenablog.com/'},
      ]
    }),
  }
</script>
